import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileExcel,
  faFileImage,
  faFileWord,
  faFilePdf,
  faFilePowerpoint,
} from "@fortawesome/free-solid-svg-icons";

export const FileType = ({ value }) => {
  let type = value.substring(value.lastIndexOf(".") + 1, value.length);
  switch (type) {
    case "jpg":
      return (
        <FontAwesomeIcon
          style={{
            fontSize: 24,
            marginTop: 0,
            color: "#632c88",
            backgroundColor: "#632c8807",
            width: 40,
            height: 40,
            borderRadius: "50%",
            padding: 10,
          }}
          icon={faFileImage}
        />
      );
    case "jif":
      return (
        <FontAwesomeIcon
          style={{
            fontSize: 24,
            marginTop: 0,
            color: "#632c88",
            backgroundColor: "#632c8807",
            width: 40,
            height: 40,
            borderRadius: "50%",
            padding: 10,
          }}
          icon={faFileImage}
        />
      );
    case "png":
      return (
        <FontAwesomeIcon
          style={{
            fontSize: 24,
            marginTop: 0,
            color: "#632c88",
            backgroundColor: "#632c8807",
            width: 40,
            height: 40,
            borderRadius: "50%",
            padding: 10,
          }}
          icon={faFileImage}
        />
      );
    case "svg":
      return (
        <FontAwesomeIcon
          style={{
            fontSize: 24,
            marginTop: 0,
            color: "#632c88",
            backgroundColor: "#632c8807",
            width: 40,
            height: 40,
            borderRadius: "50%",
            padding: 10,
          }}
          icon={faFileImage}
        />
      );
    case "pdf":
      return (
        <FontAwesomeIcon
          style={{
            fontSize: 24,
            marginTop: 0,
            color: "#d91516",
            backgroundColor: "#d9151607",
            width: 40,
            height: 40,
            borderRadius: "50%",
            padding: 10,
          }}
          icon={faFilePdf}
        />
      );
    case "doc":
      return (
        <FontAwesomeIcon
          style={{
            fontSize: 24,
            marginTop: 0,
            color: "#285294",
            backgroundColor: "#28529407",
            width: 40,
            height: 40,
            borderRadius: "50%",
            padding: 10,
          }}
          icon={faFileWord}
        />
      );
    case "docx":
      return (
        <FontAwesomeIcon
          style={{
            fontSize: 24,
            marginTop: 0,
            color: "#285294",
            backgroundColor: "#28529407",
            width: 40,
            height: 40,
            borderRadius: "50%",
            padding: 10,
          }}
          icon={faFileWord}
        />
      );
    case "xls":
      return (
        <FontAwesomeIcon
          style={{
            fontSize: 24,
            marginTop: 0,
            color: "#026f39",
            backgroundColor: "#026f3907",
            width: 40,
            height: 40,
            borderRadius: "50%",
            padding: 10,
          }}
          icon={faFileExcel}
        />
      );
    case "xlsx":
      return (
        <FontAwesomeIcon
          style={{
            fontSize: 24,
            marginTop: 0,
            color: "#026f39",
            backgroundColor: "#026f3907",
            width: 40,
            height: 40,
            borderRadius: "50%",
            padding: 10,
          }}
          icon={faFileExcel}
        />
      );
    case "ppt":
      return (
        <FontAwesomeIcon
          style={{
            fontSize: 24,
            marginTop: 0,
            color: "#c64331",
            backgroundColor: "#c6433107",
            width: 40,
            height: 40,
            borderRadius: "50%",
            padding: 10,
          }}
          icon={faFilePowerpoint}
        />
      );
    case "pptx":
      return (
        <FontAwesomeIcon
          style={{
            fontSize: 24,
            marginTop: 0,
            color: "#c64331",
            backgroundColor: "#c6433107",
            width: 40,
            height: 40,
            borderRadius: "50%",
            padding: 10,
          }}
          icon={faFilePowerpoint}
        />
      );
    default:
      return null;
  }
};
